import { buildUrl } from "helpers";
import { instance } from "libs/api";

import { ApiRoutesDeliveryFees } from "../../constants";

export const requestDeleteDeliveryZone = async (
  zoneId: string
): Promise<void> => {
  return await instance.delete(
    buildUrl(ApiRoutesDeliveryFees.DeliveryZone, zoneId)
  );
};
